import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../Context/LanguageContext';

const SEOManager = () => {
  const location = useLocation();
  const { language } = useLanguage();

  useEffect(() => {
    const routeMeta = {
      '/': {
        tr: {
          title: 'KTGPB - Kıbrıslı Türk Genç Profesyoneller Birliği',
          description: 'Kıbrıslı Türk Genç Profesyoneller Birliği - Dünya genelinde Kıbrıslı Türk profesyonelleri bir araya getiren platform.',
        },
        en: {
          title: 'KTGPB - Turkish Cypriot Young Professionals Union',
          description: 'Turkish Cypriot Young Professionals Union - A platform connecting Turkish Cypriot professionals worldwide.',
        },
      },
      '/members': {
        tr: {
          title: 'Üye Haritası - KTGPB',
          description: 'KTGPB üyelerinin dünya genelindeki dağılımını keşfedin.',
        },
        en: {
          title: 'Member Map - KTGPB',
          description: 'Explore the worldwide distribution of KTGPB members.',
        },
      },
      '/announcements': {
        tr: {
          title: 'Duyurular - KTGPB',
          description: 'KTGPB\'den en son haberler, duyurular ve güncellemeler.',
        },
        en: {
          title: 'Announcements - KTGPB',
          description: 'Latest news, announcements and updates from KTGPB.',
        },
      },
      '/jobs': {
        tr: {
          title: 'İş İlanları - KTGPB',
          description: 'KTGPB topluluğu tarafından paylaşılan kariyer fırsatları.',
        },
        en: {
          title: 'Job Listings - KTGPB',
          description: 'Career opportunities shared by the KTGPB community.',
        },
      },
      '/reports': {
        tr: {
          title: 'Raporlar - KTGPB',
          description: 'KTGPB tarafından yürütülen araştırmalar, anketler ve analizler.',
        },
        en: {
          title: 'Reports - KTGPB',
          description: 'Research, surveys and analyses conducted by KTGPB.',
        },
      },
      '/privacy': {
        tr: {
          title: 'Gizlilik Politikası - KTGPB',
          description: 'KTGPB Gizlilik Politikası: hangi bilgileri topladığımız, neden topladığımız ve haklarınız.',
        },
        en: {
          title: 'Privacy Policy - KTGPB',
          description: 'KTGPB Privacy Policy: what we collect, why we collect it and your rights.',
        },
      },
    };

    const meta = routeMeta[location.pathname]?.[language] || routeMeta['/'][language];

    // Update document title
    document.title = meta.title;

    // Update meta description
    let descTag = document.querySelector('meta[name="description"]');
    if (!descTag) {
      descTag = document.createElement('meta');
      descTag.setAttribute('name', 'description');
      document.head.appendChild(descTag);
    }
    descTag.setAttribute('content', meta.description);

    // Update Open Graph tags
    const ogTags = { 'og:title': meta.title, 'og:description': meta.description };
    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    });

    // Update html lang attribute
    document.documentElement.lang = language;
  }, [location.pathname, language]);

  return null;
};

export default SEOManager;
